import Utils from ".";

export const checkImageDimension = (file, callImageUpload, fileSize = 201) => {
  const ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png"];
  if (!ALLOWED_TYPES.includes(file.type)) {
    Utils.showAlert(2, "Invalid file type. Please upload a JPG or PNG image.");
    return;
  }
  if (file.size / 1024 > fileSize) {
    Utils.showAlert(2, `Please Upload a image less than ${fileSize - 1}kb`);
    return;
  }
  if (file && file) {
    var img = document.createElement("img");
    img.onload = function () {
      callImageUpload(this.width, this.height);
    };
    var reader = new FileReader();
    reader.onloadend = function (ended) {
      img.src = ended.target.result;
    };
    reader.readAsDataURL(file);
  }
};

export const getUserTypeFromLs = () => {
  return localStorage.getItem("userType");
};
export const getUserNameFromLs = () => {
  return localStorage.getItem("username");
};
export const setLastAnnouncement = (id) => {
  localStorage.setItem("announcmentId", id);
};
export const getLastAnnouncement = () => {
  return localStorage.getItem("announcmentId");
};
export const getUserIdFromLs = () => {
  return localStorage.getItem("id");
};

/**S
 * Who gets the notification bell, live notification toasts and the
 * /notifications inbox. Not Super Admin, not Biller.
 */
export const NO_NOTIFICATION_USER_TYPES = ["SA", "B"];
export const canSeeNotifications = () =>
  !NO_NOTIFICATION_USER_TYPES.includes(localStorage.getItem("userType"));

/**
 * The restricted Super Admin logins, picked by username ("accounts1",
 * "category2" …; see MainLayout permissions). They sign in as SA but must
 * not do full-admin actions such as deleting a PO.
 * @returns "accounts" | "category" | null
 */
export const restrictedSALogin = () => {
  const prefix = `${localStorage.getItem("username") || ""}`.slice(0, -1);
  return prefix === "accounts" || prefix === "category" ? prefix : null;
};
const commonFunction = {
  checkImageDimension,
  getUserTypeFromLs,
};

export default commonFunction;

export const removeEmptyValues = (data) => {
  for (var propName in data) {
    if (!data[propName] || data[propName].length === 0) {
      delete data[propName];
    } else if (typeof data[propName] === "object") {
      removeEmptyValues(data[propName]);
    }
  }
  return data;
};

export const breadCrumbTitle = (title) => {
  switch (title) {
    default:
      return title;
  }
};
export const getUpdatedNameSp = (name) => {
  switch (name) {
    case "purchase":
      return "purchases";
    case "purchase dashboard":
      return "purchases dashboard";
    case "invoice":
      return "sales invoice";
    case "order":
      return "sales order";
    case "delivery":
      return "delivery challan";
    default:
      return name;
  }
};
export const CustomBreadCrumb = (currentPath) => {
  const staticPath = ["/admins", "/claims", "/insurance"];

  if (staticPath.includes(currentPath)) {
    currentPath = "#";
  }

  return currentPath;
};
export const getUpdatedBreadcrumb = (pathnames) => {
  if (pathnames.includes("edit")) {
    var i = pathnames.indexOf("edit");
    var breadCrumbArray = pathnames.filter((x, y) => {
      return y <= i;
    });
    return breadCrumbArray;
  }
  if (pathnames.includes("add")) {
    var i = pathnames.indexOf("add");
    var breadCrumbArray = pathnames.filter((x, y) => {
      return y <= i;
    });
    return breadCrumbArray;
  }
  if (pathnames.includes("detail")) {
    var i = pathnames.indexOf("detail");
    var breadCrumbArray = pathnames.filter((x, y) => {
      return y <= i;
    });
    return breadCrumbArray;
  }

  // if (pathnames.includes('details')) {
  //   var i = pathnames.indexOf('details');
  //   var breadCrumbArray = pathnames.filter((x, y) => {
  //     return y <= i;
  //   });
  //   return breadCrumbArray;
  // }
  return pathnames;
};

export const toISTISO = (utcString) => {
  const date = new Date(utcString);
  const ist = new Date(date.getTime() + 19800000); // 5.5 hrs

  return ist.toISOString();
};

export const clearLocal = () => {
  // Key you want to keep
  const keepKey = "grn";
  

  // Get value before clearing
  const keepValue = localStorage.getItem(keepKey);

  // Clear all localStorage
  localStorage.clear();

  // Restore the key
  if (keepValue !== null) {
    localStorage.setItem(keepKey, keepValue);
  }
  (async () => {
    const dbs = await window.indexedDB.databases();
    dbs.forEach((db) => {
      // Note: ensure connections are closed before calling deleteDatabase in a loop
      window.indexedDB.deleteDatabase(db.name);
    });
  })();

  // continue logout logic
};
